module.exports = __webpack_public_path__ + "static/media/SarahSwitek_13_Activities-Instructions_5.e0da713e.mp3";